import { render, staticRenderFns } from "./categoryInputs.vue?vue&type=template&id=2b0a3e54&"
import script from "./categoryInputs.vue?vue&type=script&lang=js&"
export * from "./categoryInputs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports